import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {CameraModel} from '../../types/control';

import './index.scss';
import {Container} from '../../components/Container';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useOrientation} from '../../hooks/orientation';
import {CameraRenderer} from '../../components/CameraRenderer';
import {WindowUtil} from '../../utils/window';
import {backButtonToggle, groupSettingAction} from "../../store/ui/actions";

export const CameraScreen = memo(function CameraScreen() {
    const [selectedCamera, setSelectedCamera] = useState<CameraModel>(null);
    const [cameraMode, setCameraMode] = useState(null);
    const orientation = useOrientation();
    const cameraList = useSelector(state => state.control.cameraList);
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    const onCameraPress = useCallback((camera: CameraModel) => {
        if (selectedCamera) {
            setSelectedCamera(null);
            window.stop();
            window.close();
            console.log("24")
        } else {
            setSelectedCamera(camera);
        }
    }, [selectedCamera]);

    const onCameraModeChange = useCallback((mode: string) => {
        setCameraMode(mode);
        localStorage.setItem(`camera_mode_${selectedCamera?.id}`, mode);
    }, [selectedCamera?.id]);

    const cameraModeList = useMemo(() => {
        if (selectedCamera == null) {
            return [];
        }
        return [
            {text: 'RTSP', value: 'rtsp', key: 'rtsp'},
            {text: 'CGI', value: 'video_cgi', key: 'video_cgi'},
            {text: 'MJPEG', value: 'mjpeg', key: 'mjpeg'},
        ].filter(mode => selectedCamera[mode.value] != null);
    }, [selectedCamera]);

    useEffect(() => {
        dispatch(groupSettingAction({visible: false}));
    })

    useEffect(() => {
        const data = localStorage.getItem(`camera_mode_${selectedCamera?.id}`);
        if (data != null) {
            setCameraMode(data);
        } else {
            if (cameraModeList.length > 0) {
                setCameraMode(cameraModeList[0].value);
            }
        }
    }, [cameraModeList, selectedCamera?.id]);

    return (
        <Container>
            <div className="page-wrapper">
                <div className="cameras-parent">
                    {
                        cameraList.map(camera => (
                            <div
                                key={`camera_${camera.id}`}
                                className={'image-parent ' + orientation + (selectedCamera === camera ? ' selected' : '')}
                                {...onClickHandler(() => onCameraPress(camera))}>
                                {
                                    renderIf(selectedCamera)(() =>
                                        <div className="camera-button-component">
                                            {
                                                cameraModeList.map(({text, value, key}) =>
                                                    <div
                                                        className={`camera-button ${cameraMode === value ? 'active' : ''}`}
                                                        {...onClickHandler((e) => {
                                                            e.stopPropagation();
                                                            onCameraModeChange(value);
                                                        })}
                                                        key={key}>
                                                        {text}
                                                    </div>,
                                                )
                                            }
                                        </div>,
                                    )
                                }
                                <CameraRenderer
                                    className="preview"
                                    id={camera.id}
                                    mode={selectedCamera === camera ? cameraMode : 'snapshot'}
                                    quality={selectedCamera === camera ? 720 : 360}
                                />
                                <span>{camera.name}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        </Container>
    );
});
